import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getProject } from '../services/api';
import { FaGithub, FaExternalLinkAlt, FaArrowLeft } from 'react-icons/fa';
import './ProjectDetail.css';

const ProjectDetail = () => {
  const { slug } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await getProject(slug);
        setProject(response.data);
      } catch (error) {
        console.error('Error fetching project:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [slug]);

  if (loading) {
    return <div className="loading">Loading project details...</div>;
  }

  if (!project) {
    return (
      <div className="project-not-found">
        <h2>Project Not Found</h2>
        <Link to="/projects" className="btn btn-primary">
          Back to Projects
        </Link>
      </div>
    );
  }

  return (
    <div className="project-detail">
      <div className="project-header">
        <div className="project-header-content">
          <Link to="/projects" className="back-link">
            <FaArrowLeft /> Back to Projects
          </Link>
          <h1>{project.title}</h1>
          <div className="project-links">
            {project.live_url && (
              <a href={project.live_url} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                <FaExternalLinkAlt /> Live Demo
              </a>
            )}
            {project.github_url && (
              <a href={project.github_url} target="_blank" rel="noopener noreferrer" className="btn btn-outline">
                <FaGithub /> View Code
              </a>
            )}
          </div>
        </div>
      </div>

      <div className="project-content">
        <div className="project-main">
          {project.image && (
            <div className="project-image-container">
              <img src={project.image} alt={project.title} />
            </div>
          )}
          
          <div className="project-description">
            <h2>About the Project</h2>
            <p>{project.long_description || project.description}</p>
          </div>
        </div>

        <div className="project-sidebar">
          <div className="sidebar-section">
            <h3>Technologies Used</h3>
            <div className="tech-list">
              {project.tech_list?.map((tech, index) => (
                <span key={index} className="tech-item">{tech}</span>
              ))}
            </div>
          </div>

          <div className="sidebar-section">
            <h3>Project Details</h3>
            <ul className="project-meta">
              <li>
                <strong>Created:</strong> {new Date(project.created_at).toLocaleDateString()}
              </li>
              <li>
                <strong>Status:</strong> Completed
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;